export default "__VITE_ASSET__CgmyzvNc__"